<template>
  <div>
    <CourtFull
      class="court"
      expand
    />
    <TextEpsilon
      tag="div"
      class="text"
    >
      <slot/>
    </TextEpsilon>
  </div>
</template>

<script>
  import CourtFull from './CourtFull';
  import TextEpsilon from './TextEpsilon';

  export default {
    components: {
      CourtFull,
      TextEpsilon,
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .court {
    $spacing: spacing(cta);
    $size: calc(100% - #{$spacing * 2});

    position: absolute;
    top: $spacing;
    left: $spacing;
    width: $size;
    height: $size;
  }

  .link {
    position: relative;
    display: block;
    padding: spacing(cta);
  }

  .text {
    position: relative;
    text-transform: uppercase;
    padding: spacing(center-mark) spacing(center-mark) * 2;
  }
</style>
